/**
 * Enum to define meaningful for the app code carrier IDs
 */
export enum CarrierID {
  /** Home only */
  AAA = 'Q2Fycmllcjoy',
  AAG = 'Q2FycmllcjoxMzUz',
  Acceptance = 'Q2FycmllcjoxMTg4',
  Acceptance_ = 'Q2FycmllcjoxMDMy',
  AcceptanceRTR = 'Q2FycmllcjoxNDE2',
  Access = 'Q2FycmllcjoxMDM0',
  ACE = 'Q2FycmllcjoxMTU0',
  Acuity = 'Q2FycmllcjoxMDY1',
  Affirmative = 'Q2FycmllcjoxMDM1',
  AIG = 'Q2Fycmllcjoz',
  Alfa = 'Q2FycmllcjoxMzMz',
  AlinscoInsurance = 'Q2FycmllcjoxMzM1',
  AllCarriers = 'ALL_CARRIERS',
  AllianceUnited = 'Q2FycmllcjoxMDM2',
  AlliedInsurance = 'Q2Fycmllcjo0',
  ALLLInsurance = 'Q2FycmllcjoxMDY2',
  AllstarGeneralInsurance = 'Q2FycmllcjoxMjAw',
  Allstate = 'Q2Fycmllcjo1',
  AllstateInsuranceProperty = 'Q2FycmllcjoxMzc1',
  AmericanAllianceCasualtyCompany = 'Q2FycmllcjoxMTkz',
  AmericanBankersInsuranceCompany = 'Q2FycmllcjoxMTEy',
  AmericanCollectors = 'Q2FycmllcjoxMDY3',
  AmericanCommerceInsuranceCo = 'Q2FycmllcjoxMTYx',
  AmericanFamilyInsurance = 'Q2FycmllcjoxMDA1',
  AmericanModern = 'Q2FycmllcjoxMDY4',
  AmericanNational = 'Q2FycmllcjoxMDY5',
  AmericanReliableInsuranceCompany = 'Q2FycmllcjoxMTIx',
  Ameriprise = 'Q2FycmllcjoxMTIy',
  Amica = 'Q2FycmllcjoxMDE2',
  AmicaMutualInsuranceCompany = 'Q2FycmllcjoxMDE0',
  AmWINS = 'Q2FycmllcjoxMTUw',
  AnchorBlueStarPermanentGen = 'Q2FycmllcjoxMzg1',
  AnchorGeneral = 'Q2FycmllcjoxMDQw',
  AnchorGeneralGeminiAuto = 'Q2FycmllcjoxMTE0',
  AnchorGeneralInsCoTrident = 'Q2FycmllcjoxMzg2',
  AnchorGeneralMotorclub = 'Q2FycmllcjoxMTE1',
  AnchorGeneralPlatinumAuto = 'Q2FycmllcjoxMTE2',
  AnchorPacStarMedallion = 'Q2FycmllcjoxMzg4',
  AnchorPlatinumSpecial = 'Q2FycmllcjoxMzgz',
  AnchorPremier = 'Q2FycmllcjoxMzg0',
  Apollo = 'Q2FycmllcjoxNDA0',
  Apollo6Month = 'Q2FycmllcjoxNDA1',
  ApolloNewstar = 'Q2FycmllcjoxNDEx',
  ApolloSelect = 'Q2FycmllcjoxNDEy',
  ArbellaInsuranceCompany = 'Q2FycmllcjoxMDcw',
  Arrowhead = 'Q2FycmllcjoxMDQx',
  ASI = 'Q2FycmllcjoxMDEx',
  Aspen = 'Q2FycmllcjoxNDI5',
  AspenBasicPLUS = 'Q2FycmllcjoxNDMw',
  AspenCredit = 'Q2FycmllcjoxNDMx',
  AspenCreditPLUS = 'Q2FycmllcjoxNDMy',
  AspenMGARTR = 'Q2FycmllcjoxNDE1',
  AspireAdvantage = 'Q2FycmllcjoxMTY2',
  AspireGeneralInsurance = 'Q2FycmllcjoxMDQy',
  AspireInsurance = 'Q2FycmllcjoxMDcx',
  AspireSavings = 'Q2FycmllcjoxMzE4',
  AssuranceAmerica = 'Q2FycmllcjoxMzUw',
  AssuranceAmericaEconomy = 'Q2FycmllcjoxMzcy',
  AssuranceAmericaElite = 'Q2FycmllcjoxNDIz',
  AssuranceAmericaInsureMax = 'Q2FycmllcjoxMzc0',
  AssuranceAmericaProtect = 'Q2FycmllcjoxMzcz',
  Assurant = 'Q2FycmllcjoxMTQ4',
  AtlanticStatesInsuranceCompany = 'Q2FycmllcjoxMjA1',
  AutoAgencyPlus = 'Q2FycmllcjoxMTM5',
  AutoClubInsurance = 'Q2FycmllcjoxMTg3',
  AutoOwners = 'Q2FycmllcjoxMDIw',
  BambooInsurance = 'Q2FycmllcjoxMzIy',
  BearRiverMutual = 'Q2FycmllcjoxMTMy',
  BerkshireHathawayGuard = 'Q2FycmllcjoxMzU1',
  BluefireAggressiveElite = 'Q2FycmllcjoxNDE3',
  BluefireAggressiveSelect = 'Q2FycmllcjoxNDE4',
  BluefireIgnite = 'Q2FycmllcjoxNDE5',
  BluefireNations = 'Q2FycmllcjoxNDI2',
  BluefirePrime = 'Q2FycmllcjoxNDI0',
  BluefireSelectDirectBill = 'Q2FycmllcjoxNDIx',
  BluefireStandard = 'Q2FycmllcjoxNDIw',
  Branch = 'Q2FycmllcjoxMzk3',
  BristolWest = 'Q2FycmllcjoxMTI3',
  BurnsAndWilcox = 'Q2FycmllcjoxMDcy',
  CaliforniaCasualty = 'Q2FycmllcjoxMDcz',
  CapitalInsuranceGroup = 'Q2FycmllcjoxMTE4',
  CarnegieFlagship = 'Q2FycmllcjoxMzc5',
  CarnegieGeneralInsuranceAgency = 'Q2FycmllcjoxMDQz',
  CarnegieVoyager = 'Q2FycmllcjoxMzgw',
  CarneigeGeneralInsuranceAgency = 'Q2FycmllcjoxMDQz',
  CEM = 'Q2FycmllcjoxMzM4',
  Central = 'Q2FycmllcjoxMTQ5',
  CentralMutual = 'Q2FycmllcjoxMDI5',
  CenturyNational = 'Q2FycmllcjoxMzQ5',
  CHUBB = 'Q2Fycmllcjo2',
  Cincinnati = 'Q2FycmllcjoxMTMx',
  CincinnatiInsuranceAuto = 'Q2FycmllcjoxMTE3',
  ClearBlueInsurance = 'Q2FycmllcjoxMTk5',
  ClearCover = 'Q2FycmllcjoxMTM4',
  CNAFinancial = 'Q2FycmllcjoxMDc0',
  ColonialCountyMutual = 'Q2FycmllcjoxMjEy',
  Commonwealth = 'Q2FycmllcjoxMDQ0',
  ConsumersCountyMutualInsuranceCompany = 'Q2FycmllcjoxMTM1',
  CornerstoneNational = 'Q2FycmllcjoxMTI0',
  CountryFinancial = 'Q2FycmllcjoxMDIz',
  CountryMutual = 'Q2FycmllcjoxMTk0',
  CountryPreferredInsuranceCompanyA = 'Q2FycmllcjoxMjE0',
  Countryway = 'Q2FycmllcjoxMzQ1',
  Covercube = 'Q2FycmllcjoxNDIy',
  CSE = 'Q2FycmllcjoxMDA3',
  Cure = 'Q2FycmllcjoxMjAy',
  Dairyland = 'Q2FycmllcjoxMDAx',
  DairylandAutoCycle = 'Q2FycmllcjoxMDIy',
  DairylandScored = 'Q2FycmllcjoxMTY3',
  DasherInsurance = 'Q2FycmllcjoxMDc1',
  Dashers = 'Q2FycmllcjoxMTY1',
  DashersVista = 'Q2FycmllcjoxMTY0',
  DeansAndHomer = 'Q2FycmllcjoxMDc2',
  Dillo = 'Q2FycmllcjoxMTYy',
  DirectAuto = 'Q2FycmllcjoxMzY5',
  DirectGeneral = 'Q2FycmllcjoxMDM3',
  DirectGeneralAutoInsurance = 'Q2FycmllcjoxMDQ1',
  Donegal = 'Q2FycmllcjoxMzM0',
  EconomyPreferredInsuranceCompany = 'Q2FycmllcjoxMjAx',
  ElectricInsurance = 'Q2FycmllcjoxMzQx',
  ElephantAutoInsurance = 'Q2FycmllcjoxMDQ2',
  EmbarkGeneral = 'Q2FycmllcjoxMzc3',
  EmbarkGeneralIncline = 'Q2FycmllcjoxMzgx',
  EmbarkGeneralRedpoint = 'Q2FycmllcjoxMzc4',
  EmpowerAutoInsurance = 'Q2FycmllcjoxMDQ3',
  EmptyCarrier = 'Q2FycmllcjotMQ==',
  EncompassInsuranceCompany = 'Q2FycmllcjoxMDc3',
  EquityInsurance = 'Q2FycmllcjoxMzQw',
  ErieInsurance = 'Q2FycmllcjoxMDMx',
  Esurance = 'Q2Fycmllcjo3',
  ExcellentInsurance = 'Q2FycmllcjoxMzk5',
  Excepsure = 'Q2FycmllcjoxMzk4',
  FAIRINSURANCE = 'Q2FycmllcjoxMjA0',
  FarmBureau = 'Q2FycmllcjoxMjEx',
  FarmersInsurance = 'Q2Fycmllcjo4',
  FirstAcceptance = 'Q2FycmllcjoxNDE2',
  FirstAmerican = 'Q2FycmllcjoxMDA4',
  FirstAmericanPCInsCo = 'Q2FycmllcjoxMzU4',
  FirstChicagoInsurance = 'Q2FycmllcjoxMDc4',
  FirstInsuranceCompanyOfHawaii = 'Q2FycmllcjoxMDc5',
  Foremost = 'Q2FycmllcjoxMDgw',
  Founders = 'Q2FycmllcjoxMzMy',
  FoundersFRBond = 'Q2FycmllcjoxNDA2',
  FoundersIllinoisFirstChoice = 'Q2FycmllcjoxNDA4',
  FoundersIllinoisMetro = 'Q2FycmllcjoxNDA5',
  FoundersIndiana = 'Q2FycmllcjoxNDEw',
  FoundersInsurance = 'Q2FycmllcjoxNDEz',
  FoundersOhioPPA = 'Q2FycmllcjoxNDA3',
  FranklinMutual = 'Q2FycmllcjoxMDY0',
  Freedom = 'Q2FycmllcjoxMTgy',
  FreedomNational = 'Q2FycmllcjoxMTM0',
  Gainsco = 'Q2FycmllcjoxMDMz',
  Geico = 'Q2Fycmllcjo5',
  GeneralRe = 'Q2FycmllcjoxMDgx',
  GeorgiaFarmBureau = 'Q2FycmllcjoxMzM5',
  GermaniaInsurance = 'Q2FycmllcjoxMjA3',
  GermantownMutual = 'Q2FycmllcjoxMTg5',
  GMACInsurance = 'Q2FycmllcjoxMDgy',
  GoAutoInsurance = 'Q2FycmllcjoxMDQ5',
  Good2goAutoInsurance = 'Q2FycmllcjoxMDQ4',
  GrangeInsurance = 'Q2FycmllcjoxMDgz',
  Hagerty = 'Q2FycmllcjoxMDEz',
  Hallmark = 'Q2FycmllcjoxMTQw',
  HanoverInsurance = 'Q2FycmllcjoxMDg0',
  HarcoNationalInsuranceCo = 'Q2FycmllcjoxMjAz',
  HarleysvillePreferredInsuranceCompany = 'Q2FycmllcjoxMTIw',
  HartfordInsurance = 'Q2FycmllcjoxMDg1',
  Hippo = 'Q2FycmllcjoxMDE5',
  HochheimPrairie = 'Q2FycmllcjoxMzQz',
  HomesiteInsuranceCompanyOfTheMidwest = 'Q2FycmllcjoxMTE5',
  HomeState = 'Q2FycmllcjoxMTM2',
  HoraceMannInsurance = 'Q2FycmllcjoxMDUw',
  Hugo = 'Q2FycmllcjoxMzcx',
  IDS = 'Q2FycmllcjoxMTk4',
  IgnitionInsurance = 'Q2FycmllcjoxMzk2',
  IndianaFarmBureau = 'Q2FycmllcjoxMTg1',
  Infinity = 'Q2FycmllcjoxMDI1',
  InfinityEconomy = 'Q2FycmllcjoxMTY4',
  InfinityRSVP = 'Q2FycmllcjoxMTY5',
  InfinitySpecial = 'Q2FycmllcjoxMTcw',
  InsuranceCompanyOfTheSouth = 'Q2FycmllcjoxMzUx',
  InsurancePanda = 'Q2FycmllcjoxMDg2',
  InsureMax = 'Q2FycmllcjoxMzQ0',
  Integon = 'Q2FycmllcjoxMTQ0',
  Jetty = 'Q2FycmllcjoxMDE3',
  JupiterAutoInsurance = 'Q2FycmllcjoxMDUx',
  KemperAutoPremium = 'Q2FycmllcjoxMQ==',
  KemperAutoRSVP = 'Q2FycmllcjoxNDI3',
  KemperAutoSpecial = 'Q2FycmllcjoxNDI4',
  KemperPreferred = 'Q2FycmllcjoxMA==',
  Key = 'Q2FycmllcjoxMzUy',
  KIN = 'Q2FycmllcjoxMTQ3',
  LamarGeneralAgency = 'Q2FycmllcjoxMzkz',
  LegacyAutoInsurance = 'Q2FycmllcjoxMDg3',
  Lemonade = 'Q2FycmllcjoxMDE4',
  LibertyMutual = 'Q2FycmllcjoxMg==',
  Lighthouse = 'Q2FycmllcjoxMTQ2',
  LloydsOfLondon = 'Q2FycmllcjoxMTUz',
  LoneStar = 'Q2FycmllcjoxMTM3',
  LyndonSouthern = 'Q2FycmllcjoxMzQ2',
  MadisonMutual = 'Q2FycmllcjoxMzg5',
  MainStreetAmericanGroup = 'Q2FycmllcjoxMDg4',
  Mapfre = 'Q2FycmllcjoxMDUy',
  MapfreMass = 'Q2FycmllcjoxMTcx',
  MapfreProtectionEstimatedMileage = 'Q2FycmllcjoxMzk0',
  MAPFREProtectionValidatedMileage = 'Q2FycmllcjoxMzE5',
  MAPFRERoadAmericaValidatedMileage = 'Q2FycmllcjoxMzIw',
  MapfreTronweb = 'Q2FycmllcjoxMTcy',
  MapfreWA = 'Q2FycmllcjoxMTcz',
  MEEMICInsurance = 'Q2FycmllcjoxMTI4',
  MendotaAutoInsurance = 'Q2FycmllcjoxMDg5',
  MercuryAuto = 'Q2FycmllcjoxMzYx',
  MercuryHomeInsurance = 'Q2FycmllcjoxMzYy',
  Met360 = 'Q2FycmllcjoxMzYz',
  Metlife = 'Q2FycmllcjoxMDEw',
  MetLifeDirect = 'Q2FycmllcjoxMTgz',
  Metromile = 'Q2FycmllcjoxMjEz',
  metroMile = 'Q2FycmllcjoxNA==',
  MileAuto = 'Q2FycmllcjoxMzcw',
  Motion = 'Q2FycmllcjoxMzY0',
  MountainValleyIndemnity = 'Q2FycmllcjoxMTUx',
  MutualOfEnumclaw = 'Q2FycmllcjoxMTEw',
  NatGenPremier = 'Q2FycmllcjoxMDA2',
  NationalGeneral = 'Q2FycmllcjoxMDAy',
  NationalGeneralOneChoice = 'Q2FycmllcjoxMTc4',
  NationalGeneralPremier = 'Q2FycmllcjoxMTEz',
  NationalGeneralSummit = 'Q2FycmllcjoxMDA5',
  NationalGeneralValueProgram = 'Q2FycmllcjoxMDE1',
  NationsInsurance = 'Q2FycmllcjoxMDkw',
  Nationwide = 'Q2FycmllcjoxNQ==',
  NevadaGeneral = 'Q2FycmllcjoxMzQ4',
  NewJerseyMfgCompany = 'Q2FycmllcjoxMDkx',
  NewJerseySkylands = 'Q2FycmllcjoxMzM2',
  NewYorkCentralMutual = 'Q2FycmllcjoxMDMw',
  Northbrook = 'Q2FycmllcjoxMTgw',
  NorthCarolinaFarmBureau = 'Q2FycmllcjoxMTg2',
  NYCMInsurance = 'Q2FycmllcjoxMTc3',
  Occidental = 'Q2FycmllcjoxMTI2',
  OceanHarbor = 'Q2FycmllcjoxMTU4',
  OceanHarborCasualty = 'Q2FycmllcjoxMjA2',
  OhioMutualInsurance = 'Q2FycmllcjoxMDUz',
  OldAmericanCountyMutual = 'Q2FycmllcjoxMTQy',
  OMIHomeowners = 'Q2FycmllcjoxMzU2',
  OregonMutual = 'Q2FycmllcjoxMDEy',
  Other = 'Q2FycmllcjoxMDAw',
  PacificPropertyAndCasualty = 'Q2FycmllcjoxMjE1',
  PacificStar = 'Q2FycmllcjoxMzg3',
  Palomar = 'Q2FycmllcjoxMTU1',
  PalomarSpecialty = 'Q2FycmllcjoxMDky',
  PeakPropertyAndCasualtyInsurance = 'Q2FycmllcjoxMTA5',
  PEMCO = 'Q2FycmllcjoxMDkz',
  PersonalUmbrellaCorp = 'Q2FycmllcjoxMjE3',
  Philadelphia = 'Q2FycmllcjoxMDk0',
  PlymouthRock = 'Q2FycmllcjoxMDU0',
  PreferredMutual = 'Q2FycmllcjoxMDI4',
  PresidoExchange = 'Q2FycmllcjoxMDk1',
  Progressive = 'Q2FycmllcjoxNg==',
  ProntoAutoInsurance = 'Q2FycmllcjoxMDU1',
  ProntoFlex = 'Q2FycmllcjoxMTc0',
  ProntoFlexLimited = 'Q2FycmllcjoxMTc1',
  ProntoLimited = 'Q2FycmllcjoxMTc2',
  ProspectGeneral = 'Q2FycmllcjoxMDk2',
  QBE = 'Q2FycmllcjoxMDI0',
  QuantumAlliance = 'Q2FycmllcjoxMTkx',
  QuiltInsurance = 'Q2FycmllcjoxMDU2',
  QuincyMutualGroup = 'Q2FycmllcjoxMDU3',
  ReadyInsurance = 'Q2FycmllcjoxMzU5',
  RedpointCountyMutual = 'Q2FycmllcjoxMjEw',
  ResponsiveAutoInsurance = 'Q2FycmllcjoxMDk3',
  RLI = 'Q2FycmllcjoxMzYw',
  RMISAutoInsurance = 'Q2FycmllcjoxMDk4',
  ROOT = 'Q2FycmllcjoxMTQx',
  SafeAuto = 'Q2FycmllcjoxMDM4',
  Safeco = 'Q2FycmllcjoxNw==',
  SafewayInsuranceGroup = 'Q2FycmllcjoxMDk5',
  SayInsurance = 'Q2FycmllcjoxMDU5',
  SecuraInsuranceCompanies = 'Q2FycmllcjoxMDYw',
  SecurityFirst = 'Q2FycmllcjoxMTQ1',
  SelectiveInsurance = 'Q2FycmllcjoxMTAw',
  SelfInsured = 'Q2FycmllcjoxMTky',
  SentryInsurance = 'Q2FycmllcjoxMTAx',
  ShelterInsurance = 'Q2FycmllcjoxMDU4',
  SouthernCountyMutual = 'Q2FycmllcjoxMjA4',
  SouthernMutual = 'Q2FycmllcjoxMjA5',
  Spinnaker = 'Q2FycmllcjoxMTUy',
  StarCasualty = 'Q2FycmllcjoxMzQ3',
  StateAuto = 'Q2FycmllcjoxMDIx',
  StateFarm = 'Q2FycmllcjoxOA==',
  StateNational = 'Q2FycmllcjoxMzM3',
  StillwaterInsurance = 'Q2FycmllcjoxMDYx',
  SunCoastGeneralInsurance = 'Q2FycmllcjoxMDYy',
  Swyfft = 'Q2FycmllcjoxMTU3',
  TexasFarmBureau = 'Q2FycmllcjoxMTk2',
  TheCincinnatiInsuranceCompany = 'Q2FycmllcjoxMTMz',
  TheGeneral = 'Q2FycmllcjoxMDAz',
  TheHartford = 'Q2FycmllcjoxOQ==',
  TheHearth = 'Q2FycmllcjoxMzU3',
  TheNorfolkAndDedhamGroup = 'Q2FycmllcjoxMTAy',
  TitanInsurance = 'Q2FycmllcjoxMTAz',
  Topa = 'Q2FycmllcjoxMTU2',
  Traders = 'Q2FycmllcjoxNDAx',
  TradersClassic = 'Q2FycmllcjoxNDAy',
  TradersMajestic = 'Q2FycmllcjoxNDAz',
  TransUnion = 'Q2FycmllcjoxMDAwMDE=',
  Travelers = 'Q2FycmllcjoyMA==',
  Trexis = 'Q2FycmllcjoxMTk1',
  TrexisOne = 'Q2FycmllcjoxNDE0',
  TSCDirect = 'Q2FycmllcjoxMTA0',
  TwentyFirstCentury = 'Q2Fycmllcjox',
  UniqueInsurance = 'Q2FycmllcjoxMzky',
  UnitedAutomobile = 'Q2FycmllcjoxMDM5',
  UnitedPropertyAndCasualty = 'Q2FycmllcjoxMTI1',
  UnitedServiceAutomobileAssociation = 'Q2FycmllcjoxMTA1',
  UniversalPropertyAndCasulty = 'Q2FycmllcjoxMTA2',
  USAA = 'Q2FycmllcjoyMQ==',
  USAUnderwriters = 'Q2FycmllcjoxMzkw',
  UticaNationalInsurance = 'Q2FycmllcjoxMDI3',
  VelocityRiskUnderwriters = 'Q2FycmllcjoxMTkw',
  Venture = 'Q2FycmllcjoxMTk3',
  VermontMutual = 'Q2FycmllcjoxMTYw',
  Verti = 'Q2FycmllcjoxMTg0',
  WawanesaInsurance = 'Q2FycmllcjoyMg==',
  WestBendMutual = 'Q2FycmllcjoxMDI2',
  WesternGeneralAutoInsurance = 'Q2FycmllcjoxMTA3',
  WesternNational = 'Q2FycmllcjoxMzQy',
  WesternReserveGroup = 'Q2FycmllcjoxMTI5',
  WesternStarAutoInsurance = 'Q2FycmllcjoxMDYz',
  WestfieldInsurance = 'Q2FycmllcjoxMTA4',
  Westwood = 'Q2FycmllcjoxMTQz',
  Windhaven = 'Q2FycmllcjoxMTc5',
  WorkmensAutoInsurance = 'Q2FycmllcjoxMTYz',
  WorkmensAutoInsuranceCo = 'Q2FycmllcjoxMTU5',
}

const CarrierIDNicknameMap = {
  [CarrierID.Allstate]: 'Allstate',
  [CarrierID.AnchorGeneral]: 'Anchor General',
  [CarrierID.Apollo]: 'Apollo',
  [CarrierID.AspireInsurance]: 'Aspire',
  [CarrierID.AssuranceAmerica]: 'Assurance America',
  [CarrierID.CarneigeGeneralInsuranceAgency]: 'Carnegie General',
  [CarrierID.Commonwealth]: 'Commonwealth',
  [CarrierID.Dairyland]: 'Dairyland',
  [CarrierID.EmbarkGeneral]: 'Embark General',
  [CarrierID.Founders]: 'Founders',
  [CarrierID.Infinity]: 'Kemper Infinity',
  [CarrierID.KemperAutoPremium]: 'Kemper',
  [CarrierID.Mapfre]: 'MAPFRE',
  [CarrierID.MercuryAuto]: 'Mercury',
  [CarrierID.Met360]: 'MetLife',
  [CarrierID.NationalGeneral]: 'National General',
  [CarrierID.NYCMInsurance]: 'NYCM',
  [CarrierID.Traders]: 'Traders Insurance',
};

const CarrierNameNicknameMap = {
  Allstate: 'Allstate',
  'Allstate Insurance Property': 'Allstate',
  'Anchor Premier': 'Anchor General',
  'Anchor General': 'Anchor General',
  'Anchor BlueStar Permanent Gen': 'Anchor General',
  'Anchor General Ins Co Trident': 'Anchor General',
  'Anchor General Motorclub': 'Anchor General',
  'Anchor Platinum Special': 'Anchor General',
  'Anchor General Gemini Auto': 'Anchor General',
  'Apollo 6 Month': 'Apollo',
  'Aspire Insurance': 'Aspire',
  'Aspire Savings': 'Aspire',
  'Aspire General Insurance': 'Aspire',
  'Aspire Advantage': 'Aspire',
  'Assurance America': 'Assurance America',
  'Assurance America Economy': 'Assurance America',
  'Assurance America InsureMax': 'Assurance America',
  'Assurance America Protect': 'Assurance America',
  'Carnegie Flagship': 'Carnegie General',
  'Carnegie General Insurance Agency': 'Carnegie General',
  'Carnegie Voyager': 'Carnegie General',
  Dairyland: 'Dairyland',
  'Dairyland Auto & Cycle': 'Dairyland',
  'Embark General': 'Embark General',
  'Embark General Incline': 'Embark General',
  'Embark General Redpoint': 'Embark General',
  Infinity: 'Kemper Infinity',
  'Infinity RSVP': 'Kemper Infinity',
  'Infinity Special': 'Kemper Infinity',
  'Kemper Auto Premium': 'Kemper',
  'Kemper Preferred': 'Kemper',
  Mapfre: 'MAPFRE',
  'MAPFRE Protection Estimated Mileage': 'MAPFRE',
  'MAPFRE Protection Validated Mileage': 'MAPFRE',
  'MAPFRE Road America Validated Mileage': 'MAPFRE',
  'Mercury Auto': 'Mercury',
  'Mercury Home Insurance': 'Mercury',
  'National General': 'National General',
  'Home State': 'National General',
  'National General One Choice': 'National General',
  'National General Premier': 'National General',
  'National General Value Program': 'National General',
  'National General Summit': 'National General',
  'NatGen Custom 360': 'National General',
  'NYCM Insurance': 'NYCM',
  'NYCM Standard': 'NYCM',
  'Traders Classic': 'Traders Insurance',
  'Traders Majestic': 'Traders Insurance',
};

/**
 * Returns display carrier name
 */
export const getCarrierName = (name: string, id: string): string => {
  return CarrierNameNicknameMap[name] || CarrierIDNicknameMap[id] || name;
};

export const Carriers = [
  { displayName: '21st Century', id: 'Q2Fycmllcjox', name: '21st Century' },

  // A
  { displayName: 'AAA', id: 'Q2Fycmllcjoy', name: 'AAA' },
  { displayName: 'AAG', id: 'Q2FycmllcjoxMzUz', name: 'AAG' },
  { displayName: 'First Acceptance', id: 'Q2FycmllcjoxMTg4', name: 'acceptance' },
  { displayName: 'First Acceptance', id: 'Q2FycmllcjoxMDMy', name: 'Acceptance' },
  { displayName: 'Access', id: 'Q2FycmllcjoxMDM0', name: 'Access' },
  { displayName: 'ACE', id: 'Q2FycmllcjoxMTU0', name: 'ACE' },
  { displayName: 'Acuity', id: 'Q2FycmllcjoxMDY1', name: 'Acuity' },
  { displayName: 'Affirmative', id: 'Q2FycmllcjoxMDM1', name: 'Affirmative' },
  { displayName: 'AIG', id: 'Q2Fycmllcjoz', name: 'AIG' },
  { displayName: 'Alfa', id: 'Q2FycmllcjoxMzMz', name: 'Alfa' },
  { displayName: 'Alinsco', id: 'Q2FycmllcjoxMzM1', name: 'Alinsco Insurance' },
  { displayName: 'Alliance', id: 'Q2FycmllcjoxMDM2', name: 'Alliance United' },
  { displayName: 'Allied', id: 'Q2Fycmllcjo0', name: 'Allied Insurance' },
  { displayName: 'ALLL', id: 'Q2FycmllcjoxMDY2', name: 'ALLL Insurance' },
  { displayName: 'Allstar', id: 'Q2FycmllcjoxMjAw', name: 'Allstar General Insurance' },
  { displayName: 'Allstate', id: 'Q2Fycmllcjo1', name: 'Allstate' },
  { displayName: 'Allstate', id: 'Q2FycmllcjoxMzc1', name: 'Allstate Insurance Property' },
  { displayName: 'American Alliance', id: 'Q2FycmllcjoxMTkz', name: 'American Alliance Casualty Company' },
  { displayName: 'American Bankers', id: 'Q2FycmllcjoxMTEy', name: 'American Bankers Insurance Company' },
  { displayName: 'American Collectors', id: 'Q2FycmllcjoxMDY3', name: 'American Collectors' },
  { displayName: 'American Commerce', id: 'Q2FycmllcjoxMTYx', name: 'American Commerce Insurance Co' },
  { displayName: 'American Family', id: 'Q2FycmllcjoxMDA1', name: 'American Family Insurance' },
  { displayName: 'American', id: 'Q2FycmllcjoxMDY4', name: 'American Modern' },
  { displayName: 'American', id: 'Q2FycmllcjoxMDY5', name: 'American National' },
  { displayName: 'American Reliable', id: 'Q2FycmllcjoxMTIx', name: 'American Reliable Insurance Company' },
  { displayName: 'Ameriprise', id: 'Q2FycmllcjoxMTIy', name: 'Ameriprise' },
  { displayName: 'Amica Mutual', id: 'Q2FycmllcjoxMDE2', name: 'Amica' },
  { displayName: 'Amica Mutual', id: 'Q2FycmllcjoxMDE0', name: 'Amica Mutual Insurance Company' },
  { displayName: 'AmWINS', id: 'Q2FycmllcjoxMTUw', name: 'AmWINS' },
  { displayName: 'Anchor General', id: 'Q2FycmllcjoxMzg1', name: 'Anchor BlueStar Permanent Gen' },
  { displayName: 'Anchor General', id: 'Q2FycmllcjoxMDQw', name: 'Anchor General' },
  { displayName: 'Anchor General', id: 'Q2FycmllcjoxMTE0', name: 'Anchor General Gemini Auto' },
  { displayName: 'Anchor General', id: 'Q2FycmllcjoxMzg2', name: 'Anchor General Ins Co Trident' },
  { displayName: 'Anchor General', id: 'Q2FycmllcjoxMTE1', name: 'Anchor General Motorclub' },
  { displayName: 'Anchor General', id: 'Q2FycmllcjoxMTE2', name: 'Anchor General Platinum Auto' },
  { displayName: 'Anchor General', id: 'Q2FycmllcjoxMzg4', name: 'Anchor Pac Star Medallion' },
  { displayName: 'Anchor General', id: 'Q2FycmllcjoxMzgz', name: 'Anchor Platinum Special' },
  { displayName: 'Anchor General', id: 'Q2FycmllcjoxMzg0', name: 'Anchor Premier' },
  { displayName: 'Apollo', id: 'Q2FycmllcjoxNDA0', name: 'Apollo' },
  { displayName: 'Apollo', id: 'Q2FycmllcjoxNDA1', name: 'Apollo 6 Month' },
  { displayName: 'Apollo', id: 'Q2FycmllcjoxNDEx', name: 'Apollo Newstar' },
  { displayName: 'Apollo', id: 'Q2FycmllcjoxNDEy', name: 'Apollo Select' },
  { displayName: 'Apparent', id: 'Q2FycmllcjoxMzY1', name: 'Apparent' },
  { displayName: 'Arbella', id: 'Q2FycmllcjoxMDcw', name: 'Arbella Insurance Company' },
  { displayName: 'Arrowhead', id: 'Q2FycmllcjoxMDQx', name: 'Arrowhead' },
  { displayName: 'Aspen', id: 'Q2FycmllcjoxNDE1', name: 'Aspen MGA RTR' },
  { displayName: 'Aspire', id: 'Q2FycmllcjoxMTY2', name: 'Aspire Advantage' },
  { displayName: 'Aspire', id: 'Q2FycmllcjoxMDQy', name: 'Aspire General Insurance' },
  { displayName: 'Aspire', id: 'Q2FycmllcjoxMDcx', name: 'Aspire Insurance' },
  { displayName: 'Aspire', id: 'Q2FycmllcjoxMzE4', name: 'Aspire Savings' },
  { displayName: 'Assurance America', id: 'Q2FycmllcjoxMzUw', name: 'Assurance America' },
  { displayName: 'Assurance America', id: 'Q2FycmllcjoxMzcy', name: 'Assurance America Economy' },
  { displayName: 'Assurance America Elite', id: 'Q2FycmllcjoxNDIz', name: 'Assurance America Elite' },
  { displayName: 'Assurance America', id: 'Q2FycmllcjoxMzc0', name: 'Assurance America InsureMax' },
  { displayName: 'Assurance America', id: 'Q2FycmllcjoxMzcz', name: 'Assurance America Protect' },
  { displayName: 'Assurant', id: 'Q2FycmllcjoxMTQ4', name: 'Assurant' },
  { displayName: 'Atlantic States', id: 'Q2FycmllcjoxMjA1', name: 'Atlantic States Insurance Company' },
  { displayName: 'Auto Agency Plus', id: 'Q2FycmllcjoxMTM5', name: 'Auto Agency Plus' },
  { displayName: 'Auto Club Insurance', id: 'Q2FycmllcjoxMTg3', name: 'Auto club insurance' },
  { displayName: 'Auto Owners', id: 'Q2FycmllcjoxMDIw', name: 'Auto Owners' },
  { displayName: 'AutoSmart', id: 'Q2FycmllcjoxMzY4', name: 'AutoSmart' },

  // B
  { displayName: 'Bamboo', id: 'Q2FycmllcjoxMzIy', name: 'Bamboo Insurance' },
  { displayName: 'Bear River', id: 'Q2FycmllcjoxMTMy', name: 'Bear River Mutual' },
  { displayName: 'Berkshire Hathaway Guard', id: 'Q2FycmllcjoxMzU1', name: 'Berkshire Hathaway Guard' },
  { displayName: 'Bluefire', id: 'Q2FycmllcjoxNDE3', name: 'Bluefire Aggressive Elite' },
  { displayName: 'Bluefire', id: 'Q2FycmllcjoxNDE4', name: 'Bluefire Aggressive Select' },
  { displayName: 'Bluefire', id: 'Q2FycmllcjoxNDE5', name: 'Bluefire Ignite' },
  { displayName: 'Bluefire', id: 'Q2FycmllcjoxNDIx', name: 'Bluefire Select Direct Bill' },
  { displayName: 'Bluefire', id: 'Q2FycmllcjoxNDIw', name: 'Bluefire Standard' },
  { displayName: 'Branch', id: 'Q2FycmllcjoxMzk3', name: 'Branch' },
  { displayName: 'Bristol West', id: 'Q2FycmllcjoxMTI3', name: 'Bristol West' },
  { displayName: 'Burns and Wilcox', id: 'Q2FycmllcjoxMDcy', name: 'Burns and Wilcox' },

  // C
  { displayName: 'California Casualty', id: 'Q2FycmllcjoxMDcz', name: 'California Casualty' },
  { displayName: 'Capital', id: 'Q2FycmllcjoxMTE4', name: 'Capital Insurance Group' },
  { displayName: 'Carnegie General', id: 'Q2FycmllcjoxMzc5', name: 'Carnegie Flagship' },
  { displayName: 'Carnegie General', id: 'Q2FycmllcjoxMDQz', name: 'Carnegie General Insurance Agency' },
  { displayName: 'Carnegie General', id: 'Q2FycmllcjoxMzgw', name: 'Carnegie Voyager' },
  { displayName: 'CEM', id: 'Q2FycmllcjoxMzM4', name: 'CEM' },
  { displayName: 'Central', id: 'Q2FycmllcjoxMTQ5', name: 'Central' },
  { displayName: 'Central', id: 'Q2FycmllcjoxMDI5', name: 'Central Mutual' },
  { displayName: 'Century National ', id: 'Q2FycmllcjoxMzQ5', name: 'Century National ' },
  { displayName: 'CHUBB', id: 'Q2Fycmllcjo2', name: 'CHUBB' },
  { displayName: 'Cincinatti Insurance', id: 'Q2FycmllcjoxMTMx', name: 'Cincinnati' },
  { displayName: 'Cincinatti Insurance', id: 'Q2FycmllcjoxMTE3', name: 'Cincinnati Insurance Auto' },
  { displayName: 'Clear Blue', id: 'Q2FycmllcjoxMTk5', name: 'Clear Blue Insurance' },
  { displayName: 'Clearcover', id: 'Q2FycmllcjoxMTM4', name: 'Clearcover' },
  { displayName: 'CNA Financial', id: 'Q2FycmllcjoxMDc0', name: 'CNA Financial' },
  { displayName: 'Colonial County', id: 'Q2FycmllcjoxMjEy', name: 'Colonial County Mutual' },
  { displayName: 'Commonwealth', id: 'Q2FycmllcjoxMDQ0', name: 'Commonwealth Casualty Auto Insurance' },
  { displayName: 'Consumers County', id: 'Q2FycmllcjoxMTM1', name: 'Consumers County Mutual Insurance Company' },
  { displayName: 'Cornerstone National', id: 'Q2FycmllcjoxMTI0', name: 'Cornerstone National' },
  { displayName: 'Country Financial', id: 'Q2FycmllcjoxMDIz', name: 'Country Financial' },
  { displayName: 'Country Mutual', id: 'Q2FycmllcjoxMTk0', name: 'Country Mutual' },
  { displayName: 'Country Preferred', id: 'Q2FycmllcjoxMjE0', name: 'Country Preferred Insurance CompanyA' },
  { displayName: 'Countryway', id: 'Q2FycmllcjoxMzQ1', name: 'Countryway' },
  { displayName: 'Covercube', id: 'Q2FycmllcjoxNDIy', name: 'Covercube' },
  { displayName: 'CSE', id: 'Q2FycmllcjoxMDA3', name: 'CSE' },
  { displayName: 'Cure', id: 'Q2FycmllcjoxMjAy', name: 'Cure' },

  // D
  { displayName: 'Dairyland', id: 'Q2FycmllcjoxMDAx', name: 'Dairyland' },
  { displayName: 'Dairyland', id: 'Q2FycmllcjoxMDIy', name: 'Dairyland Auto & Cycle' },
  { displayName: 'Dairyland', id: 'Q2FycmllcjoxMTY3', name: 'Dairyland Scored' },
  { displayName: 'Dashers', id: 'Q2FycmllcjoxMDc1', name: 'Dasher Insurance' },
  { displayName: 'Dashers', id: 'Q2FycmllcjoxMTY1', name: 'Dashers' },
  { displayName: 'Dashers', id: 'Q2FycmllcjoxMTY0', name: 'Dashers Vista' },
  { displayName: 'Deans and Homer', id: 'Q2FycmllcjoxMDc2', name: 'Deans and Homer' },
  { displayName: 'Dillo', id: 'Q2FycmllcjoxMTYy', name: 'Dillo' },
  { displayName: 'Direct Auto', id: 'Q2FycmllcjoxMzY5', name: 'Direct Auto' },
  { displayName: 'Direct Auto', id: 'Q2FycmllcjoxMDM3', name: 'Direct General' },
  { displayName: 'Direct Auto', id: 'Q2FycmllcjoxMDQ1', name: 'Direct General Auto Insurance' },
  { displayName: 'Direct Auto', id: 'Q2FycmllcjoxMzY2', name: 'Direct General Lead Cloud' },
  { displayName: 'Donegal', id: 'Q2FycmllcjoxMzM0', name: 'Donegal' },

  // E
  { displayName: 'Economy Preferred', id: 'Q2FycmllcjoxMjAx', name: 'Economy Preferred Insurance Company' },
  { displayName: 'Electric', id: 'Q2FycmllcjoxMzQx', name: 'Electric Insurance' },
  { displayName: 'Elephant', id: 'Q2FycmllcjoxMDQ2', name: 'Elephant Auto Insurance' },
  { displayName: 'Embark General', id: 'Q2FycmllcjoxMzc3', name: 'Embark General' },
  { displayName: 'Embark General', id: 'Q2FycmllcjoxMzgx', name: 'Embark General Incline' },
  { displayName: 'Embark General', id: 'Q2FycmllcjoxMzc4', name: 'Embark General Redpoint' },
  { displayName: 'Empower', id: 'Q2FycmllcjoxMDQ3', name: 'Empower Auto Insurance' },
  { displayName: 'Encompass', id: 'Q2FycmllcjoxMDc3', name: 'Encompass Insurance Company' },
  { displayName: 'Equity', id: 'Q2FycmllcjoxMzQw', name: 'Equity Insurance' },
  { displayName: 'Erie', id: 'Q2FycmllcjoxMDMx', name: 'Erie Insurance' },
  { displayName: 'Esurance', id: 'Q2Fycmllcjo3', name: 'Esurance' },
  { displayName: 'Excellent', id: 'Q2FycmllcjoxMzk5', name: 'Excellent Insurance' },
  { displayName: 'Excepsure', id: 'Q2FycmllcjoxMzk4', name: 'Excepsure' },

  // F
  { displayName: 'Fair', id: 'Q2FycmllcjoxMjA0', name: 'FAIR INSURANCE ' },
  { displayName: 'Farm Bureau', id: 'Q2FycmllcjoxMjEx', name: 'Farm Bureau' },
  { displayName: 'Farmers', id: 'Q2Fycmllcjo4', name: 'Farmers Insurance' },
  { displayName: 'Fiesta', id: 'Q2FycmllcjoxMzY3', name: 'Fiesta' },
  { displayName: 'First Acceptance', id: 'Q2FycmllcjoxNDE2', name: 'First Acceptance' },
  { displayName: 'First American', id: 'Q2FycmllcjoxMDA4', name: 'First American' },
  { displayName: 'First American', id: 'Q2FycmllcjoxMzU4', name: 'First American P&C Ins Co' },
  { displayName: 'First Chicago', id: 'Q2FycmllcjoxMDc4', name: 'First Chicago Insurance' },
  { displayName: 'First Insurance', id: 'Q2FycmllcjoxMDc5', name: 'First Insurance Company of Hawaii' },
  { displayName: 'Foremost', id: 'Q2FycmllcjoxMDgw', name: 'Foremost' },
  { displayName: 'Founders', id: 'Q2FycmllcjoxMzMy', name: 'Founders' },
  { displayName: 'Founders', id: 'Q2FycmllcjoxNDA2', name: 'Founders FR Bond' },
  { displayName: 'Founders', id: 'Q2FycmllcjoxNDA4', name: 'Founders Illinois First Choice' },
  { displayName: 'Founders', id: 'Q2FycmllcjoxNDA5', name: 'Founders Illinois Metro' },
  { displayName: 'Founders', id: 'Q2FycmllcjoxNDEw', name: 'Founders Indiana' },
  { displayName: 'Founders', id: 'Q2FycmllcjoxNDEz', name: 'Founders Insurance' },
  { displayName: 'Founders', id: 'Q2FycmllcjoxNDA3', name: 'Founders Ohio PPA' },
  { displayName: 'Franklin', id: 'Q2FycmllcjoxMDY0', name: 'Franklin Mutual' },
  { displayName: 'Freedom National', id: 'Q2FycmllcjoxMTgy', name: 'Freedom' },
  { displayName: 'Freedom National', id: 'Q2FycmllcjoxMTM0', name: 'Freedom National' },

  // G
  { displayName: 'Gainsco', id: 'Q2FycmllcjoxMDMz', name: 'Gainsco' },
  { displayName: 'GEICO', id: 'Q2Fycmllcjo5', name: 'GEICO' },
  { displayName: 'General Re', id: 'Q2FycmllcjoxMDgx', name: 'General Re' },
  { displayName: 'Georgia Farm Bureau', id: 'Q2FycmllcjoxMzM5', name: 'Georgia Farm Bureau' },
  { displayName: 'Germania', id: 'Q2FycmllcjoxMjA3', name: 'Germania Insurance' },
  { displayName: 'Germantown', id: 'Q2FycmllcjoxMTg5', name: 'Germantown Mutual' },
  { displayName: 'GMAC', id: 'Q2FycmllcjoxMDgy', name: 'GMAC Insurance' },
  { displayName: 'GoAuto', id: 'Q2FycmllcjoxMDQ5', name: 'GoAuto Insurance' },
  { displayName: 'Good2go', id: 'Q2FycmllcjoxMDQ4', name: 'Good2go Auto Insurance' },
  { displayName: 'Grange', id: 'Q2FycmllcjoxMDgz', name: 'Grange Insurance' },

  // H
  { displayName: 'Hagerty', id: 'Q2FycmllcjoxMDEz', name: 'Hagerty' },
  { displayName: 'Hallmark', id: 'Q2FycmllcjoxMTQw', name: 'Hallmark' },
  { displayName: 'Hanover', id: 'Q2FycmllcjoxMDg0', name: 'Hanover Insurance' },
  { displayName: 'Harco National', id: 'Q2FycmllcjoxMjAz', name: 'Harco National Insurance Co' },
  { displayName: 'Harleysville Preferred', id: 'Q2FycmllcjoxMTIw', name: 'Harleysville Preferred Insurance Company' },
  { displayName: 'Hartford', id: 'Q2FycmllcjoxMDg1', name: 'Hartford Insurance' },
  { displayName: 'Hippo', id: 'Q2FycmllcjoxMDE5', name: 'Hippo' },
  { displayName: 'Hochheim Prairie', id: 'Q2FycmllcjoxMzQz', name: 'Hochheim Prairie' },
  { displayName: 'Home State', id: 'Q2FycmllcjoxMTM2', name: 'Home State' },
  { displayName: 'Homesite', id: 'Q2FycmllcjoxMTE5', name: 'Homesite Insurance Company of The Midwest' },
  { displayName: 'Horace Mann', id: 'Q2FycmllcjoxMDUw', name: 'Horace Mann Insurance' },
  { displayName: 'Hugo', id: 'Q2FycmllcjoxMzcx', name: 'Hugo' },

  // I
  { displayName: 'IDS', id: 'Q2FycmllcjoxMTk4', name: 'IDS' },
  { displayName: 'Ignition', id: 'Q2FycmllcjoxMzk2', name: 'Ignition Insurance' },
  { displayName: 'Indiana Farm Bureau', id: 'Q2FycmllcjoxMTg1', name: 'Indiana Farm Bureau' },
  { displayName: 'Kemper Infinity', id: 'Q2FycmllcjoxMDI1', name: 'Infinity' },
  { displayName: 'Kemper Infinity', id: 'Q2FycmllcjoxMTY4', name: 'Infinity Economy' },
  { displayName: 'Kemper Infinity', id: 'Q2FycmllcjoxMTY5', name: 'Infinity RSVP' },
  { displayName: 'Kemper Infinity', id: 'Q2FycmllcjoxMTcw', name: 'Infinity Special' },
  { displayName: 'Insurance Company of the South', id: 'Q2FycmllcjoxMzUx', name: 'Insurance Company of the South' },
  { displayName: 'Panda', id: 'Q2FycmllcjoxMDg2', name: 'Insurance Panda' },
  { displayName: 'Insuremax', id: 'Q2FycmllcjoxMzQ0', name: 'InsureMax' },
  { displayName: 'Integon', id: 'Q2FycmllcjoxMTQ0', name: 'Integon' },

  // J
  { displayName: 'Jetty', id: 'Q2FycmllcjoxMDE3', name: 'Jetty' },
  { displayName: 'Jupiter Auto', id: 'Q2FycmllcjoxMDUx', name: 'Jupiter Auto Insurance' },

  // K
  { displayName: 'Kemper', id: 'Q2FycmllcjoxMQ==', name: 'Kemper Auto Premium' },
  { displayName: 'Kemper', id: 'Q2FycmllcjoxMA==', name: 'Kemper Preferred' },
  { displayName: 'Key', id: 'Q2FycmllcjoxMzUy', name: 'Key' },
  { displayName: 'KIN', id: 'Q2FycmllcjoxMTQ3', name: 'KIN' },

  // L
  { displayName: 'Lamar', id: 'Q2FycmllcjoxMzkz', name: 'Lamar General Agency' },
  { displayName: 'Legacy', id: 'Q2FycmllcjoxMDg3', name: 'Legacy Auto Insurance' },
  { displayName: 'Lemonade', id: 'Q2FycmllcjoxMDE4', name: 'Lemonade' },
  { displayName: 'Liberty Mutual', id: 'Q2FycmllcjoxMg==', name: 'Liberty Mutual' },
  { displayName: 'Lighthouse', id: 'Q2FycmllcjoxMTQ2', name: 'Lighthouse' },
  { displayName: "Lloyd's of London", id: 'Q2FycmllcjoxMTUz', name: "Lloyd's of London" },
  { displayName: 'Lone Star', id: 'Q2FycmllcjoxMTM3', name: 'Lone Star' },
  { displayName: 'Lyndon Southern', id: 'Q2FycmllcjoxMzQ2', name: 'Lyndon Southern' },

  // M
  { displayName: 'Madison Mutual', id: 'Q2FycmllcjoxMzg5', name: 'Madison Mutual' },
  { displayName: 'Main Street American Group', id: 'Q2FycmllcjoxMDg4', name: 'Main Street American Group' },
  { displayName: 'Mapfre', id: 'Q2FycmllcjoxMDUy', name: 'Mapfre' },
  { displayName: 'Mapfre', id: 'Q2FycmllcjoxMTcx', name: 'Mapfre Mass' },
  { displayName: 'MAPFRE', id: 'Q2FycmllcjoxMzk0', name: 'MAPFRE Protection Estimated Mileage' },
  { displayName: 'MAPFRE', id: 'Q2FycmllcjoxMzE5', name: 'MAPFRE Protection Validated Mileage' },
  { displayName: 'MAPFRE', id: 'Q2FycmllcjoxMzIw', name: 'MAPFRE Road America Validated Mileage' },
  { displayName: 'MAPFRE', id: 'Q2FycmllcjoxMTcy', name: 'Mapfre Tronweb' },
  { displayName: 'MAPFRE', id: 'Q2FycmllcjoxMTcz', name: 'Mapfre WA' },
  { displayName: 'MEEMIC', id: 'Q2FycmllcjoxMTI4', name: 'MEEMIC Insurance' },
  { displayName: 'Mendota', id: 'Q2FycmllcjoxMDg5', name: 'Mendota Auto Insurance' },
  { displayName: 'Mercury', id: 'Q2FycmllcjoxMzYx', name: 'Mercury Auto' },
  { displayName: 'Mercury', id: 'Q2FycmllcjoxMzYy', name: 'Mercury Home Insurance' },
  { displayName: 'Met360', id: 'Q2FycmllcjoxMzYz', name: 'Met360' },
  { displayName: 'Met360', id: 'Q2FycmllcjoxMDEw', name: 'Metlife' },
  { displayName: 'Met360', id: 'Q2FycmllcjoxMTgz', name: 'MetLife Direct' },
  { displayName: 'Metromile', id: 'Q2FycmllcjoxMjEz', name: 'metromile' },
  { displayName: 'Metromile', id: 'Q2FycmllcjoxNA==', name: 'Metromile' },
  { displayName: 'Mile', id: 'Q2FycmllcjoxMzcw', name: 'Mile Auto' },
  { displayName: 'Motion', id: 'Q2FycmllcjoxMzY0', name: 'Motion' },
  { displayName: 'Mountain Valley Indemnity', id: 'Q2FycmllcjoxMTUx', name: 'Mountain Valley Indemnity' },
  { displayName: 'Mutual of Enumclaw', id: 'Q2FycmllcjoxMTEw', name: 'Mutual of Enumclaw' },

  // N
  { displayName: 'National General', id: 'Q2FycmllcjoxMDA2', name: 'Nat Gen Premier' },
  { displayName: 'National General', id: 'Q2FycmllcjoxNDAw', name: 'NatGen Custom 360' },
  { displayName: 'National General', id: 'Q2FycmllcjoxMDAy', name: 'National General' },
  { displayName: 'National General', id: 'Q2FycmllcjoxMTc4', name: 'National General One Choice' },
  { displayName: 'National General', id: 'Q2FycmllcjoxMTEz', name: 'National General Premier' },
  { displayName: 'National General', id: 'Q2FycmllcjoxMDA5', name: 'National General Summit' },
  { displayName: 'National General', id: 'Q2FycmllcjoxMDE1', name: 'National General Value Program' },
  { displayName: 'Nations Insurance', id: 'Q2FycmllcjoxMDkw', name: 'Nations Insurance' },
  { displayName: 'Nationwide', id: 'Q2FycmllcjoxNQ==', name: 'Nationwide' },
  { displayName: 'Nevada General', id: 'Q2FycmllcjoxMzQ4', name: 'Nevada General' },
  { displayName: 'New Jersey Mfg Company', id: 'Q2FycmllcjoxMDkx', name: 'New Jersey Mfg Company' },
  { displayName: 'New Jersey Skylands', id: 'Q2FycmllcjoxMzM2', name: 'New Jersey Skylands' },
  { displayName: 'NYCM', id: 'Q2FycmllcjoxMDMw', name: 'New York Central Mutual' },
  { displayName: 'North Carolina Farm Bureau', id: 'Q2FycmllcjoxMTg2', name: 'North Carolina Farm Bureau' },
  { displayName: 'Northbrook', id: 'Q2FycmllcjoxMTgw', name: 'Northbrook' },
  { displayName: 'NYCM', id: 'Q2FycmllcjoxMTc3', name: 'NYCM Insurance' },
  { displayName: 'NYCM', id: 'Q2FycmllcjoxMzgy', name: 'NYCM Standard' },

  // O
  { displayName: 'Occidental', id: 'Q2FycmllcjoxMTI2', name: 'Occidental' },
  { displayName: 'Ocean Harbor', id: 'Q2FycmllcjoxMTU4', name: 'Ocean Harbor' },
  { displayName: 'Ocean Harbor', id: 'Q2FycmllcjoxMjA2', name: 'Ocean Harbor Casualty' },
  { displayName: 'Ohio Mutual', id: 'Q2FycmllcjoxMDUz', name: 'Ohio Mutual Insurance' },
  { displayName: 'Old American County Mutual', id: 'Q2FycmllcjoxMTQy', name: 'Old American County Mutual' },
  { displayName: 'OMI Homeowners', id: 'Q2FycmllcjoxMzU2', name: 'OMI Homeowners' },
  { displayName: 'Oregon Mutual', id: 'Q2FycmllcjoxMDEy', name: 'Oregon Mutual' },

  // P
  { displayName: 'Pacific Property and Casualty', id: 'Q2FycmllcjoxMjE1', name: 'Pacific Property and Casualty' },
  { displayName: 'Anchor General', id: 'Q2FycmllcjoxMzg3', name: 'Pacific Star' },
  { displayName: 'Palomar', id: 'Q2FycmllcjoxMTU1', name: 'Palomar' },
  { displayName: 'Palomar', id: 'Q2FycmllcjoxMDky', name: 'Palomar Specialty' },
  { displayName: 'Peak', id: 'Q2FycmllcjoxMTA5', name: 'Peak Property and Casualty Insurance' },
  { displayName: 'PEMCO', id: 'Q2FycmllcjoxMDkz', name: 'PEMCO' },
  { displayName: 'Personal Umbrella Corp', id: 'Q2FycmllcjoxMjE3', name: 'Personal Umbrella Corp' },
  { displayName: 'Philadelphia', id: 'Q2FycmllcjoxMDk0', name: 'Philadelphia' },
  { displayName: 'Plymouth Rock', id: 'Q2FycmllcjoxMDU0', name: 'Plymouth Rock' },
  { displayName: 'Preferred Mutual', id: 'Q2FycmllcjoxMDI4', name: 'Preferred Mutual' },
  { displayName: 'Presido Exchange', id: 'Q2FycmllcjoxMDk1', name: 'Presido Exchange' },
  { displayName: 'Progressive', id: 'Q2FycmllcjoxNg==', name: 'Progressive' },
  { displayName: 'Progressive', id: 'Q2FycmllcjoxMDEx', name: 'Progressive - ASI' },
  { displayName: 'Pronto', id: 'Q2FycmllcjoxMDU1', name: 'Pronto Auto Insurance' },
  { displayName: 'Pronto', id: 'Q2FycmllcjoxMTc0', name: 'Pronto Flex' },
  { displayName: 'Pronto', id: 'Q2FycmllcjoxMTc1', name: 'Pronto Flex Limited' },
  { displayName: 'Pronto', id: 'Q2FycmllcjoxMTc2', name: 'Pronto Limited' },
  { displayName: 'Prospect General', id: 'Q2FycmllcjoxMDk2', name: 'Prospect General' },

  // Q
  { displayName: 'QBE', id: 'Q2FycmllcjoxMDI0', name: 'QBE' },
  { displayName: 'Quantum Alliance ', id: 'Q2FycmllcjoxMTkx', name: 'Quantum Alliance ' },
  { displayName: 'Quilt', id: 'Q2FycmllcjoxMDU2', name: 'Quilt Insurance' },
  { displayName: 'Quincy', id: 'Q2FycmllcjoxMDU3', name: 'Quincy Mutual Group' },

  // R
  { displayName: 'Ready', id: 'Q2FycmllcjoxMzU5', name: 'Ready Insurance' },
  { displayName: 'Redpoint County Mutual', id: 'Q2FycmllcjoxMjEw', name: 'Redpoint County Mutual' },
  { displayName: 'Responsive', id: 'Q2FycmllcjoxMDk3', name: 'Responsive Auto Insurance' },
  { displayName: 'RLI', id: 'Q2FycmllcjoxMzYw', name: 'RLI' },
  { displayName: 'RMIS', id: 'Q2FycmllcjoxMDk4', name: 'RMIS Auto Insurance' },
  { displayName: 'ROOT', id: 'Q2FycmllcjoxMTQx', name: 'ROOT' },

  // S
  { displayName: 'Safe Auto', id: 'Q2FycmllcjoxMDM4', name: 'Safe Auto' },
  { displayName: 'Safeco', id: 'Q2FycmllcjoxNw==', name: 'Safeco' },
  { displayName: 'Safeway', id: 'Q2FycmllcjoxMDk5', name: 'Safeway Insurance Group' },
  { displayName: 'Say', id: 'Q2FycmllcjoxMDU5', name: 'Say Insurance' },
  { displayName: 'Secura', id: 'Q2FycmllcjoxMDYw', name: 'Secura Insurance Companies' },
  { displayName: 'Security First', id: 'Q2FycmllcjoxMTQ1', name: 'Security First' },
  { displayName: 'Selective', id: 'Q2FycmllcjoxMTAw', name: 'Selective Insurance' },
  { displayName: 'Self Insured', id: 'Q2FycmllcjoxMTky', name: 'Self Insured' },
  { displayName: 'Sentry', id: 'Q2FycmllcjoxMTAx', name: 'Sentry Insurance' },
  { displayName: 'Shelter', id: 'Q2FycmllcjoxMDU4', name: 'Shelter Insurance' },
  { displayName: 'Southern County', id: 'Q2FycmllcjoxMjA4', name: 'southern county mutual' },
  { displayName: 'Southern Mutual', id: 'Q2FycmllcjoxMjA5', name: 'Southern Mutual' },
  { displayName: 'Spinnaker', id: 'Q2FycmllcjoxMTUy', name: 'Spinnaker' },
  { displayName: 'Star Casualty', id: 'Q2FycmllcjoxMzQ3', name: 'Star Casualty' },
  { displayName: 'State Auto', id: 'Q2FycmllcjoxMDIx', name: 'State Auto' },
  { displayName: 'State National', id: 'Q2FycmllcjoxMzM3', name: 'State National' },
  { displayName: 'StateFarm', id: 'Q2FycmllcjoxOA==', name: 'StateFarm' },
  { displayName: 'Stillwater', id: 'Q2FycmllcjoxMDYx', name: 'Stillwater Insurance' },
  { displayName: 'Stonegate', id: 'Q2FycmllcjoxMzk1', name: 'Stonegate' },
  { displayName: 'Sun Coast', id: 'Q2FycmllcjoxMDYy', name: 'Sun Coast General Insurance' },
  { displayName: 'Swyfft', id: 'Q2FycmllcjoxMTU3', name: 'Swyfft' },

  // T
  { displayName: 'Texas Farm Bureau', id: 'Q2FycmllcjoxMTk2', name: 'Texas Farm Bureau' },
  { displayName: 'The Cincinnati Insurance Company', id: 'Q2FycmllcjoxMTMz', name: 'The Cincinnati Insurance Company' },
  { displayName: 'The General', id: 'Q2FycmllcjoxMDAz', name: 'The General' },
  { displayName: 'The Hartford', id: 'Q2FycmllcjoxOQ==', name: 'The Hartford' },
  { displayName: 'The Hearth', id: 'Q2FycmllcjoxMzU3', name: 'The Hearth' },
  { displayName: 'The Norfolk and Dedham Group', id: 'Q2FycmllcjoxMTAy', name: 'The Norfolk and Dedham Group' },
  { displayName: 'Titan', id: 'Q2FycmllcjoxMTAz', name: 'Titan Insurance' },
  { displayName: 'Topa', id: 'Q2FycmllcjoxMTU2', name: 'Topa' },
  { displayName: 'Traders', id: 'Q2FycmllcjoxNDAx', name: 'Traders' },
  { displayName: 'Traders', id: 'Q2FycmllcjoxNDAy', name: 'Traders Classic' },
  { displayName: 'Traders', id: 'Q2FycmllcjoxNDAz', name: 'Traders Majestic' },
  { displayName: 'TransUnion', id: 'Q2FycmllcjoxMDAwMDE=', name: 'TransUnion' },
  { displayName: 'Travelers', id: 'Q2FycmllcjoyMA==', name: 'Travelers' },
  { displayName: 'Trexis', id: 'Q2FycmllcjoxMTk1', name: 'Trexis' },
  { displayName: 'Trexis', id: 'Q2FycmllcjoxNDE0', name: 'Trexis One' },
  { displayName: 'TSC', id: 'Q2FycmllcjoxMTA0', name: 'TSC Direct' },

  // U
  { displayName: 'Unique', id: 'Q2FycmllcjoxMzkx', name: 'Unique Agency Bill Real Time' },
  { displayName: 'Unique', id: 'Q2FycmllcjoxMzky', name: 'Unique Insurance' },
  { displayName: 'United', id: 'Q2FycmllcjoxMDM5', name: 'United Automobile' },
  { displayName: 'United', id: 'Q2FycmllcjoxMTI1', name: 'United Property and Casualty' },
  { displayName: 'USAA', id: 'Q2FycmllcjoxMTA1', name: 'United Service Automobile Association' },
  { displayName: 'Universal Property', id: 'Q2FycmllcjoxMTA2', name: 'Universal Property and Casulty' },
  { displayName: 'USA Underwriters', id: 'Q2FycmllcjoxMzkw', name: 'USA Underwriters' },
  { displayName: 'USAA', id: 'Q2FycmllcjoyMQ==', name: 'USAA' },
  { displayName: 'Utica National', id: 'Q2FycmllcjoxMDI3', name: 'Utica National Insurance' },

  // V
  { displayName: 'Velocity', id: 'Q2FycmllcjoxMzc2', name: 'Velocity FLEX' },
  { displayName: 'Velocity', id: 'Q2FycmllcjoxMTkw', name: 'Velocity Risk Underwriters' },
  { displayName: 'Venture', id: 'Q2FycmllcjoxMTk3', name: 'Venture' },
  { displayName: 'Vermont Mutual', id: 'Q2FycmllcjoxMTYw', name: 'Vermont Mutual' },
  { displayName: 'Verti', id: 'Q2FycmllcjoxMTg0', name: 'Verti' },

  // W
  { displayName: 'Wawanesa', id: 'Q2FycmllcjoyMg==', name: 'Wawanesa Insurance' },
  { displayName: 'West Bend Mutual', id: 'Q2FycmllcjoxMDI2', name: 'West Bend Mutual' },
  { displayName: 'Western General', id: 'Q2FycmllcjoxMTA3', name: 'Western General Auto Insurance' },
  { displayName: 'Western National', id: 'Q2FycmllcjoxMzQy', name: 'Western National' },
  { displayName: 'Western Reserve', id: 'Q2FycmllcjoxMTI5', name: 'Western Reserve Group' },
  { displayName: 'Western Star', id: 'Q2FycmllcjoxMDYz', name: 'Western Star Auto Insurance' },
  { displayName: 'Westfield', id: 'Q2FycmllcjoxMTA4', name: 'Westfield Insurance' },
  { displayName: 'Westwood', id: 'Q2FycmllcjoxMTQz', name: 'Westwood' },
  { displayName: 'Windhaven', id: 'Q2FycmllcjoxMTc5', name: 'Windhaven' },
  { displayName: "Workmen's", id: 'Q2FycmllcjoxMTYz', name: "Workmen's Auto Insurance" },
  { displayName: "Workmen's", id: 'Q2FycmllcjoxMTU5', name: "Workmen's Auto Insurance Co" },
];

export const NationalGeneralCarrierIDs = [
  CarrierID.NationalGeneral,
  CarrierID.NationalGeneralOneChoice,
  CarrierID.NationalGeneralPremier,
  CarrierID.NationalGeneralSummit,
  CarrierID.NationalGeneralValueProgram,
];

export const KemperCarrierIDs = [
  CarrierID.KemperAutoPremium,
  CarrierID.KemperPreferred,
  CarrierID.KemperAutoRSVP,
  CarrierID.KemperAutoSpecial,
];

export const AnchortCarrierIDs = [
  CarrierID.AnchorBlueStarPermanentGen,
  CarrierID.AnchorGeneralInsCoTrident,
  CarrierID.AnchorGeneral,
  CarrierID.AnchorGeneralGeminiAuto,
  CarrierID.AnchorGeneralMotorclub,
  CarrierID.AnchorGeneralPlatinumAuto,
  CarrierID.AnchorPlatinumSpecial,
  CarrierID.AnchorPremier,
];

export const AspireCarrierIDs = [
  CarrierID.AspireInsurance,
  CarrierID.AspireGeneralInsurance,
  CarrierID.AspireAdvantage,
  CarrierID.AspireSavings,
];

export const BluefireIgniteCarrierIDs = [
  CarrierID.BluefireAggressiveElite,
  CarrierID.BluefireAggressiveSelect,
  CarrierID.BluefireIgnite,
  CarrierID.BluefireStandard,
  CarrierID.BluefireSelectDirectBill,
  CarrierID.BluefireNations,
  CarrierID.BluefirePrime,
];

export const AssuranceAmericaCarriersIDs = [
  CarrierID.AssuranceAmerica,
  CarrierID.AssuranceAmericaEconomy,
  CarrierID.AssuranceAmericaInsureMax,
  CarrierID.AssuranceAmericaProtect,
  CarrierID.AssuranceAmericaElite,
];

export const DairylandCarrierIDs = [CarrierID.DairylandScored, CarrierID.Dairyland, CarrierID.DairylandAutoCycle];

export const TrexisCarrierIDs = [CarrierID.Trexis, CarrierID.TrexisOne];

export const AspenCarrierIDs = [
  CarrierID.Aspen,
  CarrierID.AspenBasicPLUS,
  CarrierID.AspenCredit,
  CarrierID.AspenCreditPLUS,
  CarrierID.AspenMGARTR,
];

export const EmbarkCarrierIDs = [
  CarrierID.EmbarkGeneral,
  CarrierID.EmbarkGeneralRedpoint,
  CarrierID.EmbarkGeneralIncline,
];

export const ApolloCarrierIDs = [
  CarrierID.Apollo,
  CarrierID.Apollo6Month,
  CarrierID.ApolloNewstar,
  CarrierID.ApolloSelect,
];

export const POPULAR_CARRIERS = [
  CarrierID.Progressive,
  CarrierID.Geico,
  ...NationalGeneralCarrierIDs,
  CarrierID.BristolWest,
  CarrierID.ROOT,
  ...KemperCarrierIDs,
  ...AnchortCarrierIDs,
  ...AspireCarrierIDs,
  ...BluefireIgniteCarrierIDs,
  CarrierID.Lemonade,
  ...AssuranceAmericaCarriersIDs,
  CarrierID.MendotaAutoInsurance,
  CarrierID.TheGeneral,
  CarrierID.Safeco,
  CarrierID.SafeAuto,
  ...DairylandCarrierIDs,
  ...TrexisCarrierIDs,
  ...AspenCarrierIDs,
  ...EmbarkCarrierIDs,
  CarrierID.Commonwealth,
  CarrierID.Gainsco,
  CarrierID.Other,
  CarrierID.LibertyMutual,
  CarrierID.Excepsure,
  ...ApolloCarrierIDs,
];
